import { render, staticRenderFns } from "./Gaji.vue?vue&type=template&id=d1dba746&scoped=true"
import script from "./Gaji.vue?vue&type=script&lang=js"
export * from "./Gaji.vue?vue&type=script&lang=js"
import style0 from "./Gaji.vue?vue&type=style&index=0&id=d1dba746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dba746",
  null
  
)

export default component.exports